import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ITableMenu, IOption } from "./TableMenuInterfaces";
import { useStyles, paperPropsStyles } from "./TableMenu.styles";

export const TableMenu = ({ options }: ITableMenu) => {
    const classes = useStyles();

    const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorElement);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorElement(event.currentTarget);
    };
    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorElement(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorElement}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: paperPropsStyles,
                }}
            >
                {options.map((option: IOption, index: number) => {
                    const menuItem = (
                        <MenuItem
                            disabled={option?.disabled}
                            className={classes.item}
                            style={{
                                ...(option.customStyles && option.customStyles),
                            }}
                            onClick={(event) => {
                                option.callback();
                                handleClose(event);
                            }}
                        >
                            {option.name}
                        </MenuItem>
                    );
                    return (
                        <div key={index}>
                            {option?.disabled && option?.disabledTooltip ? (
                                <Tooltip
                                    PopperProps={{ className: classes.tooltip }}
                                    title={
                                        <Typography className={classes.tooltipTexts}>
                                            {option.disabledTooltip}
                                        </Typography>
                                    }
                                >
                                    <span style={{ display: "block" }}>{menuItem}</span>
                                </Tooltip>
                            ) : (
                                menuItem
                            )}
                        </div>
                    );
                })}
            </Menu>
        </div>
    );
};
